<template>
    <footer class="text-center bg-gray-900 text-white mb-14 sm:mb-0" v-if=" isShowFooter ">
        <div class="px-6 pt-1" style="max-width: 1280px; margin: 0 auto;">
          <div class="mt-1 mb-3 lg:mb-6 lg:mt-3">
            <ul class="flex flex-wrap py-2 lg:py-4" style="border-bottom: 1px solid #eee;"> <!-- lg:flex-none lg:grid lg:grid-cols-4 md:grid-cols-2 -->
              <li class="text-left p-1 lg:w-1/6"><a @click="goAutoLogin('brand', '')" class="cursor-pointer text-white hover:text-blue-400 text-sm lg:text-base lg:border-0 lg:pr-0 border-r border-white pr-2">About the company</a></li><!-- 회사소개 -->
              <!-- 페이지 이동 약관 -->
              <li class="text-left p-1 lg:w-1/6"><a href="/msTerms" class="cursor-pointer text-white hover:text-blue-400 text-sm lg:text-base lg:border-0 lg:pr-0 border-r border-white pr-2">Terms &amp; Conditions</a></li>
              <li class="text-left p-1 lg:w-1/6"><a href="/msPrivacyPolicy" class="cursor-pointer text-white hover:text-blue-400 text-sm lg:text-base lg:border-0 lg:pr-0 border-r border-white pr-2">Privacy Policy</a></li>
              <li class="text-left p-1 lg:w-1/6"><a href="/msShippingPolicy" class="cursor-pointer text-white hover:text-blue-400 text-sm lg:text-base lg:border-0 lg:pr-0 border-r border-white pr-2">Shipping Policy</a></li>
              <li class="text-left p-1 lg:w-1/6"><a href="/msReturnPolicy" class="cursor-pointer text-white hover:text-blue-400 text-sm lg:text-base lg:border-0 lg:pr-0 border-r border-white pr-2">Return Policy</a></li>
              <li class="text-left p-1 lg:w-1/6"><a href="/msAcademyInfo" class="cursor-pointer text-white hover:text-blue-400 text-sm lg:text-base">Academy directory</a></li>
              <!--          <li><a target="_blank" v-bind:href="cdn_url + '/shop/storage/pdf/my/policies_mal.pdf'">Policies and Procedures</a></li>--><!-- 쇼핑몰 이용가이드 -->
              <!-- 구 cdn 연결 약관 -->
              <!--
              <li><a target="_blank" v-bind:href="cdn_url + '/shop/storage/pdf/my/terms_mal.pdf'">Terms &amp; Conditions</a></li>
              <li><a target="_blank" v-bind:href="cdn_url + '/shop/storage/pdf/my/privacy_mal.pdf'"><span style="color:tomato;">Privacy Policy</span></a></li>
              <li><a target="_blank" v-bind:href="cdn_url + '/shop/storage/pdf/my/Shipping Policy.pdf'">Shipping Policy</a></li>
              <li><a target="_blank" v-bind:href="cdn_url + '/shop/storage/pdf/my/GCOOP%20MAL%20Return%20Policy.pdf'">Return Policy</a></li>
              -->
            </ul>

          </div>

<!--            <div>-->
<!--                <form action="">-->
<!--                    <div class="grid md:grid-cols-3 gird-cols-1 gap-4 flex justify-center items-center">-->
<!--                        <div class="md:ml-auto md:mb-6">-->
<!--                            <p class="">-->
<!--                                <strong>Sign up for our newsletter</strong>-->
<!--                            </p>-->
<!--                        </div>-->

<!--                        <div class="md:mb-6">-->
<!--                            <input-->
<!--                                type="text"-->
<!--                                class="-->
<!--                form-control-->
<!--                block-->
<!--                w-full-->
<!--                px-3-->
<!--                py-1.5-->
<!--                text-base-->
<!--                font-normal-->
<!--                text-gray-700-->
<!--                bg-white bg-clip-padding-->
<!--                border border-solid border-gray-300-->
<!--                rounded-->
<!--                transition-->
<!--                ease-in-out-->
<!--                m-0-->
<!--                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none-->
<!--              "-->
<!--                                id="exampleFormControlInput1"-->
<!--                                placeholder="Email address"/>-->
<!--                        </div>-->

<!--                        <div class="md:mr-auto mb-6">-->
<!--                            <button type="submit" class="inline-block px-6 py-2 border-2 border-white text-white font-medium text-xs leading-tight uppercase rounded hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out">-->
<!--                                Subscribe-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </form>-->
<!--            </div>-->

            <div class="relative mb-6"><!-- grid lg:grid-cols-4 md:grid-cols-2 -->
<!--                <div class="mb-6 hidden lg:block">
                    <h5 class="uppercase font-bold mb-2.5">PRODUCTS</h5>

                    <ul class="list-none mb-0">
                        <li v-for="item in navigations" :key="item.name">
                            <a :href="item.href" class="text-white">{{ item.name }}</a>
                        </li>
                    </ul>
                </div>-->

                <div class="mb-4 text-left">
                    <h5 class="uppercase font-bold mb-1 text-left text-sm lg:text-lg lg:mb-2.5">COMMUNITY</h5>
                    <ul class="list-none mb-0">
                        <li>
                            <a href="/Mypage/Notice" class="text-slate-300 text-sm lg:text-base hover:text-blue-400">Announcements</a>
                        </li>
                    </ul>
                </div>

              <div class="mb-4 text-left">
                <h5 class="uppercase font-bold mb-1 text-left text-sm lg:text-lg lg:mb-2.5">INFORMATION</h5>
                <ul class="list-none">
                  <li class="text-sm text-slate-300 lg:text-base xl:mb-2 lg:mb-2 mb-1">
                    Address : No 5, Jalan PPU 2A, Taman Perindustrian Puchong Utama, 47100 Puchong Selangor.
                  </li>
                  <li class="text-sm text-slate-300 lg:text-base xl:mb-2 lg:mb-2 mb-1">
                    E-mail : <a class="text-slate-300 hover:text-blue-400" href="mailto:Info.my@gcoop.com">info.my@gcoop.com</a>
                  </li>
                  <li class="text-sm text-slate-300 lg:text-base">
                    GCOOP MALAYSIA SDN.BHD. (1324296-A) AJL932399
                  </li>
                </ul>
              </div>

                <div class="mb-4 text-left">
                    <h5 class="uppercase font-bold mb-1 text-left text-sm lg:text-lg lg:mb-2.5">CS CENTER</h5>
                    <ul class="list-none mb-0 lg:flex">
                        <li class="text-sm text-slate-300 lg:text-base">Business hours : 09:00 ~ 18:00</li>
                        <li class="text-sm text-slate-300 lg:text-base lg:pl-3">Lunch hour : 12:00 ~ 13:00</li>
                        <li class="text-sm text-slate-300 lg:text-base lg:pl-3">Closed: Sat/Sun/Holiday</li>
                    </ul>
                </div>



              <div class="text-left lg:absolute lg:bottom-0 lg:right-4 xl:grid xl:grid-cols-3 lg:grid lg:grid-cols-2 flex gap-3">
                <div class="grid grid-rows-1">
                  <ul class="list-none mb-0 text-left">
                    <li><a href="https://dsam.org.my/" target="_blank" class="text-white">
                      <img src="https://cdn.gcoop.me/shop/storage/images/my/logo_DSAM.jpg" alt="DSAM" class="xl:w-[126px] lg:w-[126px] w-[88px]"> <!--  mx-auto -->
                    </a>
                    </li>
                  </ul>
                </div>
                <div class="grid grid-rows-2">
                  <h5 class="uppercase font-bold mb-1 text-left text-sm lg:text-lg lg:mb-2.5 flex justify-center">Shipping</h5>
                  <ul class="list-none mb-0 text-left flex items-center justify-center">
                    <li><a href="https://gdexpress.com/" target="_blank" class="text-white">
                      <img src="https://cdn.gcoop.me/shop/storage/images/my/logo_gdex.png" alt="GDEX" class="w-20 lg:w-20"> <!--  mx-auto -->
                    </a>
                    </li>
                  </ul>
                </div>
                  <div class="grid grid-rows-1">
                    <ul class="list-none mb-0 text-left">
                      <li><a href="https://www.best-inc.my/" target="_blank" class="text-white">
                        <img src="https://cdn.gcoop.me/shop/storage/images/my/best_express.png" alt="BEST EXPRESS" class="xl:w-[100px] lg:w-[100px] w-[88px] xl:h-[88px] lg:h-[88px]"> <!--  mx-auto -->
                      </a>
                      </li>
                    </ul>
                  </div>
              </div>

            </div>

        </div>



      <div class="flex justify-center mb-6" v-if="false">
        <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
          <svg  aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="kakaotalk"
                class="w-8 h-full mx-auto"
                role="img"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 300 300">
            <!--                        <path d="M24 11C15.1634 11 8 16.6482 8 23.6154C8 28.1198 10.9948 32.0723 15.4997 34.3042C15.2546 35.1494 13.9248 39.7417 13.8718 40.1025C13.8718 40.1025 13.84 40.3735 14.0155 40.4769C14.1911 40.5803 14.3975 40.5 14.3975 40.5C14.9009 40.4297 20.2349 36.6829 21.1582 36.0323C22.0805 36.1629 23.0302 36.2308 24 36.2308C32.8366 36.2308 40 30.5828 40 23.6154C40 16.6482 32.8366 11 24 11Z" fill="white"/>-->
            <!--                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1538 28.0193C14.6447 28.0193 14.2307 27.6239 14.2307 27.1377V21.6539H12.7904C12.2909 21.6539 11.8846 21.2483 11.8846 20.75C11.8846 20.2517 12.291 19.8462 12.7904 19.8462H17.5172C18.0167 19.8462 18.423 20.2517 18.423 20.75C18.423 21.2483 18.0166 21.6539 17.5172 21.6539H16.0769V27.1377C16.0769 27.6239 15.6629 28.0193 15.1538 28.0193ZM23.2479 28.0073C22.863 28.0073 22.5686 27.851 22.4798 27.5996L22.0227 26.403L19.2079 26.4028L18.7506 27.6002C18.6621 27.8511 18.3678 28.0073 17.9829 28.0073C17.7804 28.0075 17.5802 27.964 17.3961 27.8799C17.1416 27.7625 16.897 27.4397 17.1773 26.5691L19.3853 20.7574C19.5409 20.3154 20.0133 19.86 20.6146 19.8463C21.2175 19.8599 21.6899 20.3154 21.8458 20.7583L24.0529 26.5674C24.3338 27.44 24.0892 27.763 23.8347 27.88C23.6505 27.964 23.4504 28.0074 23.2479 28.0073ZM20.6153 22.1487L21.5373 24.7679H19.6933L20.6153 22.1487ZM25.5384 27.8847C25.0505 27.8847 24.6538 27.505 24.6538 27.0385V20.7693C24.6538 20.2602 25.0765 19.8462 25.5961 19.8462C26.1156 19.8462 26.5384 20.2602 26.5384 20.7693V26.1923H28.4999C28.9878 26.1923 29.3846 26.572 29.3846 27.0385C29.3846 27.505 28.9878 27.8847 28.4999 27.8847H25.5384ZM29.7436 27.0842C29.7436 27.5933 30.1576 28.0073 30.6667 28.0073C30.9115 28.0069 31.1462 27.9095 31.3193 27.7364C31.4924 27.5633 31.5898 27.3286 31.5901 27.0837V25.0697L31.9104 24.7494L34.0752 27.6177C34.1609 27.7322 34.2722 27.825 34.4003 27.8888C34.5283 27.9525 34.6695 27.9853 34.8125 27.9847C35.0131 27.9851 35.2082 27.9197 35.3678 27.7983C35.4648 27.7256 35.5464 27.6344 35.6079 27.5299C35.6693 27.4254 35.7095 27.3097 35.7259 27.1896C35.7432 27.0695 35.7364 26.9473 35.7059 26.8299C35.6755 26.7125 35.6221 26.6023 35.5487 26.5057L33.2765 23.4956L35.3801 21.3923C35.5247 21.2476 35.5972 21.048 35.5838 20.8303C35.5705 20.6145 35.4741 20.4067 35.3124 20.2451C35.139 20.0719 34.9076 19.9725 34.6772 19.9725C34.4796 19.9725 34.2976 20.0454 34.1652 20.1779L31.5898 22.7533V20.7693C31.5898 20.2602 31.1758 19.8462 30.6667 19.8462C30.1576 19.8462 29.7436 20.2602 29.7436 20.7693V27.0842Z" fill="black"/>-->
            <path fill-rule="evenodd" clip-rule="evenodd" fill="white" d="m150 300c-83 0-150-67.1-150-150c0-83 67-150 150-150c82.9 0 150 67 150 150c0 82.9-67.1 150-150 150zm-53.1-85.6c-1.6 5.3-9.9 34-10.2 36.2c0 0-0.2 1.7 0.9 2.4c1.1 0.6 2.4 0.1 2.4 0.1c3.1-0.4 36.5-23.8 42.2-27.9q8.7 1.2 17.8 1.2c55.2 0 100-35.3 100-78.8c0-43.5-44.8-78.9-100-78.9c-55.2 0-100 35.4-100 78.9c0 28.1 18.7 52.9 46.9 66.8z"/>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="white" d="m95.7 175.1c-3.2 0-5.8-2.5-5.8-5.5v-34.3h-9c-3.1 0-5.6-2.5-5.6-5.6c0-3.1 2.5-5.7 5.6-5.7h29.6c3.1 0 5.6 2.6 5.6 5.7c0 3.1-2.5 5.6-5.6 5.6h-9v34.3c0 3-2.6 5.5-5.8 5.5zm50.6-0.1c-2.4 0-4.2-0.9-4.8-2.5l-2.9-7.5h-17.6l-2.8 7.5c-0.6 1.6-2.4 2.5-4.8 2.5c-1.3 0-2.5-0.2-3.7-0.8c-1.6-0.7-3.1-2.7-1.3-8.1l13.8-36.4c0.9-2.7 3.9-5.6 7.6-5.7c3.8 0.1 6.8 3 7.7 5.7l13.8 36.3c1.8 5.5 0.3 7.5-1.3 8.3c-1.2 0.5-2.4 0.7-3.7 0.7zm-10.7-20.2l-5.8-16.4l-5.7 16.4zm25 19.5c-3.1 0-5.5-2.4-5.5-5.3v-39.2c0-3.2 2.6-5.8 5.9-5.8c3.2 0 5.8 2.6 5.8 5.8v33.9h12.3c3 0 5.5 2.4 5.5 5.3c0 2.9-2.5 5.3-5.5 5.3zm32.1 0.7c-3.2 0-5.8-2.5-5.8-5.7v-39.5c0-3.2 2.6-5.8 5.8-5.8c3.1 0 5.7 2.6 5.7 5.8v12.4l16.1-16.1c0.8-0.8 2-1.3 3.2-1.3c1.5 0 2.9 0.6 4 1.7c1 1 1.6 2.3 1.7 3.7c0.1 1.3-0.4 2.6-1.3 3.5l-13.1 13.1l14.2 18.9q0.7 0.9 0.9 2q0.3 1.1 0.2 2.2q-0.2 1.2-0.8 2.2q-0.6 0.9-1.5 1.6c-1 0.8-2.2 1.2-3.4 1.2c-0.9 0-1.8-0.2-2.6-0.6c-0.8-0.4-1.5-1-2-1.7l-13.6-17.9l-2 2v12.6c0 1.5-0.6 3-1.7 4.1c-1.1 1-2.5 1.6-4 1.6z"/>
          </svg>
        </a>

        <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
          <svg aria-hidden="true"
               focusable="false"
               data-prefix="fab"
               data-icon="facebook-f"
               class="w-3 h-full mx-auto"
               role="img"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 320 512"
          >
            <path
              fill="currentColor"
              d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
            ></path>
          </svg>
        </a>

        <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
          <svg aria-hidden="true"
               focusable="false"
               data-prefix="fab"
               data-icon="twitter"
               class="w-4 h-full mx-auto"
               role="img"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
            ></path>
          </svg>
        </a>

        <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
          <svg aria-hidden="true"
               focusable="false"
               data-prefix="fab"
               data-icon="google"
               class="w-4 h-full mx-auto"
               role="img"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 488 512"
          >
            <path
              fill="currentColor"
              d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
            ></path>
          </svg>
        </a>

        <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
          <svg aria-hidden="true"
               focusable="false"
               data-prefix="fab"
               data-icon="instagram"
               class="w-4 h-full mx-auto"
               role="img"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
            ></path>
          </svg>
        </a>

        <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
          <svg aria-hidden="true"
               focusable="false"
               data-prefix="fab"
               data-icon="linkedin-in"
               class="w-4 h-full mx-auto"
               role="img"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
            ></path>
          </svg>
        </a>

        <!--                <a href="#" type="button" class="rounded-full border-2 border-white text-white leading-normal uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-9 h-9 m-1">
                            <svg aria-hidden="true"
                                 focusable="false"
                                 data-prefix="fab"
                                 data-icon="github"
                                 class="w-4 h-full mx-auto"
                                 role="img"
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 496 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                                ></path>
                            </svg>
                        </a>-->
      </div>

      <!-- 풋터 최하단 -->
      <div class="bg-black/20 text-center p-4 text-sm lg:pb-4 md:pb-20">
        <div class="lg:flex items-center justify-between m-auto" style="max-width:1280px;">
          <div class="hidden lg:block"><img src="https://cdn.gcoop.me/shop/storage/images/my/img_footer_logo_wh.png" alt="GCOOP"></div>
          <a class="text-white text-xs hover:text-white lg:text-base md:text-sm" href="https://brand.gcoop.com/ms/" target="_blank">© {{ this_year }} Copyright : GCOOP Malaysia Sdn. Bhd.</a>
        </div>
      </div>

    </footer>
</template>

<script>


export default {
    name: "LayoutBottom",
    props: ['this_year'],
    data: () => ({
        isShowFooter: false,
        product_categorys: [],
      // navigations: [],
        cdn_url: process.env.MIX_CDN_URL
    }),
    created() {
        // 카테고리 메뉴
      // this.navigations = this.product_category;
    },
    mounted() {
        setTimeout(() => {
          this.isShowFooter = true;
          // Code here
        }, 2000);
    },
    methods : {
      goAutoLogin(mode, url) {
          window.open("https://brand.gcoop.com/AppUserLogin?xid="+window.Laravel.xid_info+"&token="+window.Laravel.xid_info+"&url=/ms");

          // let config = {
        //   headers: {
        //     Authorization: 'Bearer ' + window.Laravel.access_token
        //   }
        // };
        //
        // axios.post(window.Laravel.back_url +'/api/goAutoLogin',{
        //   mode: mode,
        //   url: url,
        //   bz_cd: window.Laravel.bz_cd,
        // },config).then(response => {
        //     if(response.data.href_url != ""){
        //       window.open(response.data.href_url);
        //     }
        //   }).catch(e => {
        //   });
      },
    }
}
</script>

<style scoped>

</style>
